import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@shared/components/button/button.component';
import { FormsModule } from '@angular/forms';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { NotesComponent } from '@shared/components/notes/notes.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { SharedModule } from '@shared/shared.module';
import { AvatarComponent } from '@shared/components/avatar/avatar.component';
import { MatTooltip } from '@angular/material/tooltip';
import { BehaviorSubject } from 'rxjs';
import { SearchModel } from '@shared/model/search-model';
import { SearchService } from '@shared/services/search.service';

@Component({
  selector: 'app-header-search',
  imports: [
    CommonModule,
    MatDialogContent,
    SharedModule,
    MatDialogClose,
    AvatarComponent,
    MatTooltip,
    FormsModule,
  ],
  templateUrl: './header-search.component.html',
  standalone: true,
  styleUrl: './header-search.component.css',
})
export class HeaderSearchComponent {
  searchModel: SearchModel = new SearchModel();
  item = {
    userList: [
      { id: 1, displayName: 'Alice Johnson' },
      { id: 2, displayName: 'Bob Smith' },
      { id: 3, displayName: 'Charlie Davis' },
      { id: 4, displayName: 'Diana Prince' },
      { id: 5, displayName: 'Ethan Hunt' },
    ],
  };
  constructor(
    private dialogRef: MatDialogRef<HeaderSearchComponent>,
    private searchService: SearchService
  ) {}

  ngOnInit(): void {
    this.searchService.currentSearch$.subscribe(s => {
      this.searchModel = { ...s }; // spread to avoid binding directly to BehaviorSubject value
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  getRemainingNames(userList: any[]): string {
    const remaining = userList.slice(3);
    return remaining.map((u) => u.displayName).join(', ');
  }

  changeSearch() {
    this.searchService.updateSearch(this.searchModel);
    this.cancel();
  }

  preventCharacters(event: KeyboardEvent) {
    const forbiddenKeys = ["'", '"']; // List of forbidden characters
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault(); // Prevent entering the forbidden characters
    }
  }

  handlePaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const items = clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === 'file') {
          // An image was pasted, prevent further handling
          event.preventDefault();
          return;
        }
      }
    }
    // If no image is detected, let the input event handle the search
  }
}
